import { Box, Flex, FlexProps, Stack, Text } from '@chakra-ui/react';
import { size } from 'lodash';
import Button from '~/components/Button';
import { DefaultMediaPackType } from '~/types';
import { convertPxToRems } from '~/utils-ts';

import {
  DEFAULT_AFFINITIES,
  DEFAULT_CONTENT_STRENGTHS,
  DEFAULT_EXPERIENCE,
} from '../MediaPacksDefaultTemplate/AboutYou/AboutYou.constants';

interface Props extends FlexProps {
  mediaPack: DefaultMediaPackType;
}

export const TagsSection: React.FC<Props> = ({
  mediaPack = {} as DefaultMediaPackType,
}) => {
  const themesAndAffinities: string[] =
    mediaPack.themesAndAffinities && mediaPack.themesAndAffinities.length > 0
      ? mediaPack.themesAndAffinities
      : DEFAULT_AFFINITIES;
  const contentStrengths: string[] =
    mediaPack.contentStrengths && mediaPack.contentStrengths?.length > 0
      ? mediaPack.contentStrengths
      : DEFAULT_CONTENT_STRENGTHS;
  const experienceTags: string[] =
    mediaPack.experienceTags && mediaPack.experienceTags?.length > 0
      ? mediaPack.experienceTags
      : DEFAULT_EXPERIENCE;

  let shouldDisplayExperienceSection: boolean = size(experienceTags) > 0;

  return (
    <Stack
      width="100%"
      maxWidth={convertPxToRems(1500)}
      paddingX={{
        base: 8,
        md: 20,
        xl: 48,
      }}
      spacing={10}
      direction={{
        base: 'column',
        md: 'row',
      }}
      marginX="auto"
      marginTop={{ base: 10, lg: 4 }}
    >
      <Box display="flex" flexDirection="column" gap={4}>
        <Text
          fontSize="lg"
          fontWeight="medium"
          lineHeight={convertPxToRems(19)}
          letterSpacing="wide"
        >
          Themes & affinities
        </Text>
        <Flex flexWrap="wrap" gap={2}>
          {themesAndAffinities.map((affinity) => (
            <Button
              as="span"
              key={affinity}
              variant="outline"
              colorScheme="primary"
              size="sm"
              letterSpacing={convertPxToRems(0.4)}
              lineHeight={convertPxToRems(17)}
              // To override default hover and active styles
              _hover={{}}
              _active={{}}
            >
              {affinity}
            </Button>
          ))}
        </Flex>
      </Box>

      <Box display="flex" flexDirection="column" gap={4}>
        <Text
          fontSize="lg"
          fontWeight="medium"
          lineHeight={convertPxToRems(19)}
          letterSpacing="wide"
        >
          Content strengths
        </Text>
        <Flex flexWrap="wrap" gap={2}>
          {contentStrengths.map((strength) => (
            <Button
              as="span"
              key={strength}
              colorScheme="primary"
              size="sm"
              backgroundColor="primary.700"
              letterSpacing="wide"
              lineHeight={convertPxToRems(17)}
              // To override default hover and active styles
              _hover={{}}
              _active={{}}
            >
              {strength}
            </Button>
          ))}
        </Flex>
      </Box>

      {shouldDisplayExperienceSection && (
        <Box display="flex" flexDirection="column" gap={4}>
          <Text
            fontSize="lg"
            fontWeight="medium"
            lineHeight="19px"
            letterSpacing="wide"
            data-testid="experience-title"
          >
            Experience
          </Text>
          <Flex flexWrap="wrap" gap={2}>
            {experienceTags.map((experience) => (
              <Button
                as="span"
                key={experience}
                colorScheme="secondary"
                size="sm"
                letterSpacing={convertPxToRems(0.4)}
                lineHeight={convertPxToRems(17)}
                // To override default hover and active styles
                _hover={{}}
                _active={{}}
              >
                {experience}
              </Button>
            ))}
          </Flex>
        </Box>
      )}
    </Stack>
  );
};
